import { differenceInDays, differenceInWeeks, differenceInMonths } from 'date-fns';

import type { DateRangeType } from '../../store/storeTypes';

import { AnalyticsContainer } from './analyticsSharedConstants';
import type { PeriodType } from './PeriodSelector';

/**
 * If the date range is less than 2 days, and the analytics container is page level, period will be an hour.
 * If the date range is less than or equal to 6 weeks, period will be a day.
 * If the date range is less than or equal to 6 months, period will be a week.
 * Otherwise, period will be a month.
 * @param fromDate the start date of the range
 * @param toDate  the end date of the range
 * @param analyticsContainer the container type
 *
 * @returns the period type based on the date range
 */
export const getDefaultPeriodBasedOnDateRange = (
	fromDate: Date,
	toDate: Date,
	analyticsContainer: AnalyticsContainer,
): PeriodType => {
	if (analyticsContainer === AnalyticsContainer.PAGE) {
		if (differenceInDays(toDate, fromDate) <= 2) {
			return 'hour';
		}
	}

	if (differenceInWeeks(toDate, fromDate) <= 6) {
		return 'day';
	}
	if (differenceInMonths(toDate, fromDate) <= 6) {
		return 'week';
	}
	return 'month';
};

export const getDefaultPeriodBasedOnRangeType = (rangeType: DateRangeType | null): PeriodType => {
	if (rangeType === 'AllTime' || rangeType === '7D') {
		return 'week';
	}

	return 'month';
};
